import React from 'react';
import ScreenComponent from "../../components/screenComponent";
import {withRouter} from "react-router-dom";
import {Get, Post} from "../../components/request";
import screens from "../../screens";
import DivTable from "../../components/divTable";
import {Button} from "react-bootstrap";
import Commentaire from "./commentaire";
import Security from "../../components/security";

class SignaturePAE extends ScreenComponent {

    constructor(props) {
        super(props);
        this.state = {
            InscriptionID: null,
            PAE: null,
            commentaire: null,
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        let {body} = await Get(`/v1/extranet/student/${screens.SignaturePAE}`);

        this.setState({
            InscriptionID: body.InscriptionID,
            PAE: body.Items
        });
    }

    updateCommentaire(commentaire = null) {
        this.setState({
            commentaire: commentaire
        }, function () {
            this.save(false);
        });
    }

    async save(signature) {
        await Post(`/v1/extranet/student/${screens.SignaturePAE}`, {
            InscriptionID: this.state.InscriptionID,
            signature: signature,
            commentaire: this.state.commentaire
        }, "Sauvegarde en cours..", {render: "Sauvegarde réussie !"}, {render: "Erreur lors de la sauvegarde"});

        let {body} = await Get(`/v1/extranet/student/${screens.SignaturePAE}`);

        if (body === null) {
            Security.denyPage(screens.SignaturePAE);
        }

        this.props.history.push(process.env.APP_ROOT + 'desktop');
    }

    renderPAE() {
        return (
            <>
                <p className={"mb-5"}>Vérifiez une dernière fois votre PAE et si tout est en ordre, cliquez sur « Signer
                    mon PAE en ligne ».
                    <br/>Au cas où vous constateriez une anomalie, cliquez sur « Je signale un problème à mon
                    coordinateur ».
                    <br/>En signant votre PAE, vous indiquez avoir pris connaissance du <a href="https://files.ichec.be/HE-Reglements-Etudes.pdf" target="_blank" rel="noopener noreferrer">règlement général des études</a>
                </p>
                <DivTable columns={{
                    "Code": "ConstitutionProgrammeUECode",
                    "Libellé": "ConstitutionProgrammeUELibelle",
                    "Quadri": "ConstitutionProgrammeUEQuadri",
                    "ECTS": "ConstitutionProgrammeUEECTS",
                }}
                          array={this.state.PAE.filter(f => !f.IsTransfert)}/>
                <br/>
                <br/>
                <h5 className={"float-right mr-3 pr-5"}><u>Total
                    ECTS</u>: {this.state.PAE.filter(f => !f.IsTransfert).reduce((a, b) => a + b.ConstitutionProgrammeUEECTS, 0)}
                </h5>
                {this.state.PAE.filter(f => f.IsTransfert).length > 0 &&
                <>
                    <br/>
                    <br/>
                    <br/>
                    <h3>Crédits validés dans un autre diplôme</h3>
                    <DivTable columns={{
                        "Code": "ConstitutionProgrammeUECode",
                        "Libellé": "ConstitutionProgrammeUELibelle",
                        "Quadri": "ConstitutionProgrammeUEQuadri",
                        "ECTS": "ConstitutionProgrammeUEECTS",
                    }}
                              array={this.state.PAE.filter(f => f.IsTransfert)}/>
                    <br/>
                    <br/>
                    <h5 className={"float-right mr-3 pr-5"}><u>Total
                        ECTS</u>: {this.state.PAE.filter(f => f.IsTransfert).reduce((a, b) => a + b.ConstitutionProgrammeUEECTS, 0)}
                    </h5>
                </>}
                <br/>
                <br/>
                <br/>
                <Button block size={"lg"} variant={"success"}
                        onClick={this.save.bind(this, true)}>Signer mon PAE en ligne</Button>
                <Button block size={"lg"} variant={"warning"}
                        onClick={() => this.refCommentaire.update(true, false, this.state.commentaire)}>Je signale un
                    problème à mon coordinateur</Button>
                <Commentaire ref={r => this.refCommentaire = r}
                             update={this.updateCommentaire.bind(this)}/>
            </>
        );
    }

    render() {
        return (
            <section>
                {this.state.PAE && this.renderPAE()}
            </section>
        );
    }
}

export default withRouter(SignaturePAE);